// import Vue from 'vue'
import SetService from '@/services/set.service'

const user_settings = JSON.parse(localStorage.getItem('user_settings'));

const settings_state = user_settings
  ? { user_settings: user_settings }
  : { user_settings: {} };

const initialState = {
  tunes: [],
  userProfile: settings_state,
  sets: [],
  set: {},
  recordings: [],
  ctx: null
}


export const tune = {
  namespaced: true,
  state: initialState,
  getters: {
  },
  mutations: {
    setCtx(state, val) {
      state.ctx = val;
    },
    setUserProfile(state, val){
      state.userProfile = val;
      if (val.user_settings){
        localStorage.setItem('user_settings', JSON.stringify(val.user_settings));
      }
    },
    addSet(state, val) {
      state.sets.push(val)
    },
    setSetList(state, val) {
      state.sets = val;
    },
    setTuneList(state, val) {
      state.tunes = val;
    },
    setRecordingList(state, val) {
      state.recordings = val;
    },
    setSetDetail(state, val) {
      state.set = val;
    },
    addSetting(state, val) {
      state.set.settings.push(val);
    },
    updateSetting(state, val) {
      const itemIndex = state.set.settings.findIndex(x => x.id === val.id)
      state.set.settings.splice(itemIndex, 1, val);
    },
    deleteSetting(state, val) {
      state.set.settings.splice(
        state.set.settings.indexOf(val),
        1
      );
    },
    addRecordingToTune(state, tuneId, val) {
      const tuneIndex = state.tunes.findIndex(x => x.id === tuneId)
      state.tunes[tuneIndex].recordings.push(val);
    }
  },
  actions: {
    //// APP ACTIONS
    createCtx({commit}) {
      commit('setCtx')
    },

    //// CRUD ACTIONS
    addSetting({ commit }, payload) {
      return SetService.addSettingToSet(payload.set_id, payload.setting).then(
        res => {
          commit('addSetting', res.data)
          return Promise.resolve(res.data.id);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateSetting({ commit }, payload) {
      return SetService.updateSetting(payload.setting_id, payload.data).then(
        res => {
          commit('updateSetting', res.data)
          return Promise.resolve(res.data.id);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    //// CRUD ACTIONS
    setSettingOrder({ commit }, payload) {
      return SetService.setSettingOrder(payload.set_id, payload.order).then(
        res => {
          commit('setSetDetail', res.data)
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteSetting({ commit }, payload) {
      return SetService.deleteSetting(payload.id).then(
        res => {
          commit('deleteSetting', payload)
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    createSet({ commit }, payload) {
      return SetService.createSet(payload).then(
        res => {
          commit('addSet', res.data)
          return Promise.resolve(res.data.id);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getSetList({ commit }) {
      return SetService.getSetList().then(
        res => {
          commit('setSetList', res.data);
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getSetDetail({ commit }, id) {
      return SetService.getSetDetail(id).then(
        res => {
          commit('setSetDetail', res.data);
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getTuneList({ commit }) {
      return SetService.getTuneList().then(
        res => {
          commit('setTuneList', res.data);
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getUserProfile({ commit }) {
      return SetService.getUserProfile().then(
        res => {
          commit('setUserProfile', res.data[0]);
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateUserProfile({ commit }, payload) {
      return SetService.updateUserProfile(payload.id, payload.data).then(
        res => {
          commit('setUserProfile', res.data)
          return Promise.resolve(res.data.id);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    addRecording({ commit }, formData) {
      return SetService.createRecording(formData).then(
        res => {
          commit('addRecordingToTune', formData['tune_id'], res.data)
          return Promise.resolve(res.data.id);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getRecordingList({ commit }) {
      return SetService.getRecordingList().then(
        res => {
          commit('setRecordingList', res.data);
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updatePosition(_, payload) {
      return SetService.updatePosition(payload.id, payload).then(
        res => {
          return Promise.resolve(res);
        },
        error => {
          return Promise.reject(error);
        }
      );
    }
  },
  modules: {
  }
}
